import { HSL_MAX_VISIBLE_LIGHTNESS, HSL_MIN_VISIBLE_LIGHTNESS, HSL_DESATURATION_THRESHOLD } from './constants';
export function isColorVisible([, s, l]) {
  return l < HSL_MAX_VISIBLE_LIGHTNESS && l > HSL_MIN_VISIBLE_LIGHTNESS && s > HSL_DESATURATION_THRESHOLD;
}
export function getHSLAString([h, s, l], alpha = 0.7) {
  return `hsla(${h}, ${s}%, ${l}%, ${alpha})`;
}
export const isBrowser = () => typeof window !== 'undefined';
//# sourceMappingURL=utils.js.map